import React from "react";

import { Box, FormControl, FormHelperText, TextField } from "@mui/material";

const DomainField = ({ value, error, language, onChange }) => {
    const hasError = error === null;
    return (
        <Box sx={{ mt: 1, mb: 3 }}>
            <FormControl fullWidth error={hasError}>
                <TextField
                    id="domain"
                    label={language?.source_modal?.domain ?? "Domain"}
                    variant="outlined"
                    value={value ?? ""}
                    onChange={(event) => onChange(event.target.value)}
                    placeholder="https://www.example.com"
                    error={hasError}
                />
                {error && (
                    <FormHelperText>
                        {language?.source_modal?.validation_error ??
                            "Validation Error"}
                    </FormHelperText>
                )}
            </FormControl>
        </Box>
    );
};

export default DomainField;
